import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar.component';


export interface SnackType {
  type:
  'success'
  | 'error'
  | 'warning'
  | 'info';
  params?: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private _snackBar: MatSnackBar) { }

  public open(message: string, snackTypeParameter: SnackType, duration?: number): void {
    setTimeout(() => {
      this._snackBar.openFromComponent(SnackbarComponent, {
        duration: duration ? duration : 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        data: {
          message: message.toString() || '',
          snackType: snackTypeParameter,
          title: snackTypeParameter.type?.toString().toUpperCase() || '',
        },
        panelClass: [this.getStyle(snackTypeParameter)],
      });
    }, 500);
  }

  private getStyle(snackType: SnackType): string {
    switch (snackType.type) {
      case 'success':
        return 'success-msg';
      case 'error':
        return 'error-msg';
      case 'warning':
        return 'warning-msg';
      case 'info':
        return 'info-msg';
    }
  }
}

